import React from 'react';
import './ProfileCompletion.css'; // Archivo CSS para los estilos
import { FaPencilAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Avatar } from 'antd';
import PropTypes from 'prop-types';
import AvatarForm from '../../forms/AvatarForm';

class ProfileCompletion extends React.Component {
  render() {
    const { completedPercentage, member } = this.props;

  const levelName = member? member.memberShipName: "Blue";
    return (
      <div className="profile-container">
        <AvatarForm 
          imgUrl={member?.profilePic || member?.avatar} 
          style={{ width: 80, height: 80 }}
          className="profile-image"
        />
        {/* <Avatar 
          src={member?.profilePic || member?.avatar} 
          style={{ width: 80, height: 80 }}
          className="profile-image"
        /> */}
        <div className="profile-info">
          <div className="profile-title">Sandos4U {levelName.toUpperCase()}</div>
          <div className="profile-subtitle">
            {this.context.t('Profile Completed')} {completedPercentage}%
          </div>
          <div className="progress-bar-profile">
            <div
              className="progress"
              style={{ width: `${completedPercentage}%` }}
            ></div>
          </div>
          <div className="change-password-link">
            <Link to={'/reset-password'}>
              {this.context.t('Change password')}
            </Link>
            <FaPencilAlt className="pencil-icon" />
          </div>
        </div>
      </div>
    );
  }
}

ProfileCompletion.propTypes = {
  completedPercentage: PropTypes.number,
  member: PropTypes.object,
};

ProfileCompletion.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default ProfileCompletion;
